module.exports = __webpack_public_path__ + "img/arrow-bar-right.78b83eb5.svg";